const state = {
  currentLanguage: "",
  languages: [],
  bForced: false
};

export default state;
